module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-carousel.e08d49f5.png";